import { Table, Skeleton } from "@mantine/core";

export function TableSkeleton({ length = 20, cols = 6 }) {
  const rows = Array.from({ length: length }).map((_, index) => (
    <Table.Tr key={index}>
      {Array.from({ length: cols }).map((_, colIndex) => (
        <Table.Td key={colIndex}>
          <Skeleton height={27} radius="sm" />
        </Table.Td>
      ))}
    </Table.Tr>
  ));

  return <Table.Tbody pos="relative">{rows}</Table.Tbody>;
}
